import { ConfigProvider } from '@mono-farmart-web/farmart-ai';
import { SessionProvider } from '@mono-farmart-web/farmart-ai';
import { UserProvider } from '@mono-farmart-web/farmart-ai';
import { Box } from '@mui/joy';
import React, { Suspense, useRef } from 'react';
import { APIContainer } from '@mono-farmart-web/farmart-ai';
import { uuid } from '@mono-farmart-web/utilities/utils';
import useFarmartAIConfig from '../../../hooks/ai/useAppConfig';
import Header from './Header';
import LazyLoader from './Loader';

const FarmartAIChatComponent = React.lazy(() =>
	import('@mono-farmart-web/farmart-ai/components/chat').then(module => ({
		default: module.default,
	})),
);

interface IFarmartAIModalContent {
	initialModelMessage?: string;
	headerText: string;
	additionalContext: string;
	initialInput?: string;
	onClose: () => void;
}

const FarmartAIModalContent = ({
	initialModelMessage,
	initialInput,
	additionalContext,
	headerText,
	onClose,
}: IFarmartAIModalContent) => {
	const {
		customHeaders,
		userMeta,
		getIsInternalRoute,
		isAndroidApp,
		userId,
		customBodyParams,
	} = useFarmartAIConfig();
	const chatId = useRef(uuid()).current;

	return (
		<Box sx={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
			<SessionProvider>
				<UserProvider globalUserId={userId}>
					<ConfigProvider
						userMeta={userMeta}
						customHeaders={customHeaders}
						baseRoute='/'
						isAndroidApp={isAndroidApp}
						isStandalone={false}
						getIsInternalRoute={getIsInternalRoute}
						featureManager={{
							isQuickPromptsEnabled: false,
							isAudioUploadEnabled: false,
							isDocumentUploadEnabled: false,
							isChatHistoryEnabled: false,
						}}
						chatManager={{
							chatId: chatId,
							initialInput: initialInput,
							initialMessages: initialModelMessage
								? [
										{
											role: 'model',
											text: initialModelMessage,
										},
									]
								: undefined,
						}}
						customBodyParams={{
							additional_context: additionalContext,
							...customBodyParams,
						}}
					>
						<APIContainer>
							{/* Handle Bar */}
							<Box
								sx={{
									width: '40px',
									height: '4px',
									backgroundColor: '#E0E0E0',
									borderRadius: '2px',
									margin: '16px auto 4px auto',
									cursor: 'grab',
								}}
								onClick={onClose}
							/>

							<Header headerText={headerText} chatId={chatId} />

							{/* Scrollable Chat List Area */}
							<Box
								sx={{
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
									backgroundColor: 'white',
									overflow: 'hidden',
									px: 2,
								}}
							>
								<Suspense fallback={<LazyLoader />}>
									<FarmartAIChatComponent />
								</Suspense>
							</Box>

							{/* Sticky Footer */}
							<Box
								sx={{
									p: 2,
								}}
							/>
						</APIContainer>
					</ConfigProvider>
				</UserProvider>
			</SessionProvider>
		</Box>
	);
};

export default FarmartAIModalContent;
